import { FREEMIUM_PRODUCTS_DAYS_LEFT } from '../actions/freemiumProdDaysLeftActions';

export function FreemiumProdDaysLeftReducer(prevState: any = {}, action: any = {}) {
    switch (action.type) {
        case FREEMIUM_PRODUCTS_DAYS_LEFT:
            return action.value;
        default:
            return prevState;
    }
}
